import {type IconObject} from  '@/ts/types';

export default class PlaceType {

  constructor(public id: number, public name: string, public icon: string | IconObject, public group: Object) {
  }
}
